export default __webpack_public_path__ + "static/media/ListZigzag.a0dbcfc7.svg";